<formstep-detail ref="formstepDetail" :options="options" :editable="canEdit" :model="serverfunktion"></formstep-detail>